import { render, staticRenderFns } from "./ProseMirrorEditor.vue?vue&type=template&id=897cda18&scoped=true&"
import script from "./ProseMirrorEditor.vue?vue&type=script&lang=js&"
export * from "./ProseMirrorEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProseMirrorEditor.vue?vue&type=style&index=0&id=897cda18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897cda18",
  null
  
)

export default component.exports